import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose
} from '@angular/material/dialog';
import { Booking } from '../../models/booking';
import { DocketService, ProductService } from '../../shared';
import { ProductCategoryService } from '../../shared/services/product-category.service';
import { DepotLocation, Docket, Product } from '../../models';
import { UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { ConfigService } from '../../shared/services/config.service';
import { Router } from '@angular/router';
import { MatButton } from '@angular/material/button';
import { AssignItemsTableComponent } from '../../shared/assign-items-table/assign-items-table.component';
import { FlexModule } from '@angular/flex-layout';
import { AlertTextComponent } from 'src/app/shared/alert-text/alert-text.component';

@Component({
  selector: 'transfer-booking-contract-dialog',
  templateUrl: './transfer-to-contract-dialog.component.html',
  styleUrls: ['./transfer-to-contract-dialog.component.css'],
  providers: [DocketService, ProductService, ProductCategoryService],
  standalone: true,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    FlexModule,
    AssignItemsTableComponent,
    MatDialogActions,
    AlertTextComponent,
    MatButton,
    MatDialogClose
  ]
})
export class TransferToContractDialogComponent implements OnDestroy, OnInit {
  booking: Booking;
  alternativeProductItems: { [bookingId: number]: Product[] } = {};
  formGroup: UntypedFormGroup;
  private ngUnsubscribe = new Subject<void>();
  currentLocation: DepotLocation;
  saving = false;

  constructor(
    public dialogRef: MatDialogRef<TransferToContractDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private docketService: DocketService,
    private router: Router,
    private configService: ConfigService
  ) {
    this.booking = data;
  }

  ngOnInit() {
    this.configService.currentLocation.subscribe((location) => {
      this.currentLocation = location;
    });
  }

  save() {
    this.saving = true;
    const data = {
      items: this.getOnHireItems()
    };
    this.docketService.createFromBooking(this.booking.id, data).subscribe(
      (response: Docket) => {
        this.router.navigate(['docket', response.id], {
          queryParams: { createdFromBooking: true }
        });
        this.dialogRef.close();
      },
      (error) => {
        this.saving = false;
      }
    );
  }

  private getOnHireItems() {
    const items = [];
    const now = new Date();
    this.formGroup.value.items.forEach(({ bookingItem, item, quantity }) => {
      const hireItem = {
        booking_item_id: bookingItem.id,
        item_id: item.id,
        on_hire: now,
        estimated_off_hire:
          new Date(bookingItem.off_hire).getTime() > now.getTime()
            ? bookingItem.off_hire
            : null,
        notes: bookingItem.notes,
        quantity: quantity,
        location_out: this.currentLocation.id,
        charge: bookingItem.charge
      };
      items.push(hireItem);
    });
    return items;
  }

  formSet(form: UntypedFormGroup) {
    this.formGroup = form;
  }

  formArraySet(form: UntypedFormGroup) {
    this.formGroup = form;
    console.log({ form });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
